import React, { Suspense, useMemo } from 'react';
import { Route, Switch } from 'react-router';
import { useSelector } from 'react-redux';

import { getRoutePathForLeadTab } from '@crm-lead/base';

import { IStateWithLead, RouterConfigItem } from './types';
import { leadActions } from './store';
import { getLead } from './selectors';

type GetRoutesParams = {
  accessibleRoutes: RouterConfigItem[];
  leadId: number;
};

interface IComponentWrapperProps {
  accessibleRoutes: RouterConfigItem[];
  leadId: number;
  routeKey: string;
}

export const ComponentWrapper: React.FC<IComponentWrapperProps> = React.memo(
  ({ accessibleRoutes, routeKey, leadId }) => {
    const { component: Component } =
      accessibleRoutes.find((item) => item.key === routeKey) || {};

    const lead = useSelector((state: IStateWithLead) =>
      getLead(state, Number(leadId))
    );

    return (
      <>
        {Component ? (
          <Component
            getLeadFromServer={leadActions.getLeadFromServer}
            setLead={leadActions.setLead}
            lead={lead!}
          />
        ) : null}
      </>
    );
  }
);

const getRoutesComponents = ({ leadId, accessibleRoutes }: GetRoutesParams) =>
  accessibleRoutes
    .map((routeItem) => ({
      ...routeItem,
      fallback: () => <div>Fallback</div>,
      allowedView: [],
    }))
    .map(
      ({ key, path, exact }): React.FC =>
        () =>
          (
            <Route
              key={key}
              path={getRoutePathForLeadTab(path)}
              exact={exact}
              render={() => (
                <ComponentWrapper
                  accessibleRoutes={accessibleRoutes}
                  routeKey={key}
                  leadId={leadId}
                  key={key}
                />
              )}
            />
          )
    );

export const LeadRouter: React.FC<GetRoutesParams> = React.memo(
  ({ leadId, accessibleRoutes }) => {
    const routes = useMemo(
      () =>
        getRoutesComponents({
          leadId,
          accessibleRoutes,
        }),
      [leadId, accessibleRoutes]
    );

    return (
      <Switch>
        <Suspense fallback={<div>Loading...</div>}>
          {routes.map((Tab) => (
            <Tab />
          ))}
        </Suspense>
      </Switch>
    );
  }
);
